import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-refund",
  "use": "icon-refund-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-refund\"><path d=\"M798.912 96L928 270.08v658.176H96V270.144L225.088 96h573.824zm38.72 264.448H186.368v477.504h651.264V360.448zm-221.312 61.76l63.872 63.872-105.216 105.088L680.192 696.32l-63.872 63.872L511.104 655.04l-105.28 105.152-63.872-63.872 105.216-105.152L341.952 486.08l63.872-63.872 105.28 105.152L616.32 422.208zm140.416-235.904H273.408l-61.888 83.84h608l-62.784-83.84z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol